import { Routes, Route, Navigate } from "react-router-dom";


// import ProjectLogistics from "./ProjectLogistics";

const regionalTradesRoutes = [
    // {routeName: 'exhibition-events-logistics' , component: <ProjectLogistics/>},
    // {routeName: 'professional-team' , component: <ProjectLogistics/>},
    // {routeName: 'transportation' , component: <ProjectLogistics/>},
   
    // {routeName: 'value-added-services' , component: <Warehousing/>},
    // {routeName: 'primary-secondary-distribution' , component: <Warehousing/>},
   
];

const RegionalTradesRoutes = () => {
    return (
    <Routes>
       {regionalTradesRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default RegionalTradesRoutes;